import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { Text } from '@/components/shared/components/Text';

export const ArticleCategoryAlert = () => {
  return (
    <CustomCartAlert severity={'warning'} icon={'warning'}>
      <Text tId={'CART_ALERT_ARTICLE_CATEGORY'}></Text>
    </CustomCartAlert>
  );
};
